import type { SurveyAnswerRecord, SurveyAnswerValue } from '@coorum-research/shared-common/types/answer.type'
import type { Question } from 'survey-core' // 型データのみ利用
import type { ISurveyCreator } from 'survey-react-ui'
import { normalizePanelData } from '../../utils/panel-answer.util'
import { SurveyQuestionAnswerFile } from './SurveyQuestionAnswerFile'
import { SurveyQuestionAnswerRating } from './SurveyQuestionAnswerRating'

type Props = {
  creator: ISurveyCreator
  question: Question
  answerData: SurveyAnswerRecord
}

/**
 * answer 回答表示用のコンポーネント
 * question type === 'panel'
 * survey-coreに完全には依存せず、answerDataから直接データを取得
 */
export function SurveyQuestionAnswerPanel({ creator, question, answerData }: Props) {
  // panel内の各質問を取得（textまたはcommentタイプのみ）
  const questionWithElements = question as Question & { elements?: Question[] }
  const panelQuestions: Question[] = questionWithElements.elements || []

  // パネルの回答データを取得（survey-coreに依存せず、直接answerDataから取得）
  const rawPanelData = answerData[question.name]

  // パネルデータの正規化
  const panelAnswerData = normalizePanelData(rawPanelData, panelQuestions)

  return (
    <div className="flex flex-col gap-3">
      {panelQuestions.map((panelQuestion: Question) => (
        <div key={panelQuestion.name} className="flex flex-col gap-1">
          <div className="text-sm font-bold">
            {panelQuestion.title}
          </div>
          <div className="text-sm">
            {(() => {
              // パネル内の質問の回答を取得
              const panelQuestionValue = panelAnswerData[panelQuestion.name] as SurveyAnswerValue
              const panelQuestionComment = panelAnswerData[`${panelQuestion.name}-Comment`] as string | undefined

              if (panelQuestionValue === undefined || panelQuestionValue == null || panelQuestionValue === '') {
                return <span className="text-gray-400">未回答</span>
              }

              // パネル内の質問の値とコメントを設定
              panelQuestion.value = panelQuestionValue
              if (panelQuestionComment !== undefined) {
                panelQuestion.comment = panelQuestionComment
              }

              switch (panelQuestion.getType()) {
                case 'file':
                  return (
                    <SurveyQuestionAnswerFile
                      creator={creator}
                      question={panelQuestion}
                    />
                  )
                case 'rating':
                  return (
                    <SurveyQuestionAnswerRating
                      question={panelQuestion}
                    />
                  )
                default:
                  return (
                    <div className="whitespace-pre-wrap">
                      {String(panelQuestionValue)}
                    </div>
                  )
              }
            })()}
          </div>
        </div>
      ))}
    </div>
  )
}
